



































import { BlogFilter } from 'client-website-ts-library/filters';
import { Blog, BlogType } from 'client-website-ts-library/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { API } from 'client-website-ts-library/services';

import Masonry from './Layout/Masonry.vue';
import Cards from './Layout/Cards.vue';

@Component({
  components: {
    Masonry,
  },
})
export default class Blogs extends Vue {
  @Prop({ required: true })
  public filter!: BlogFilter;

  @Prop({ default: false })
  public hideFirstBlog!: boolean;

  public loading = false;

  public posts: Blog[] = [];

  public load(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.loading) resolve(false);

      this.loading = true;

      API.Blogs.Search(this.filter).then((data) => {
        this.posts = data.filter((b) => b.Type !== BlogType.Suburb);

        this.loading = false;
      }).catch(reject);
    });
  }

  mounted() {
    this.load();
  }

  @Watch('filter')
  handleFilterChanged() {
    this.load();
  }
}
